export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YL5rilQs6yLUrwB0lw.a9688c68.woff2";